import { useEffect, useState } from 'react'
import { api, imHintergrund } from './api'
import { anzahlwort, belegtext, t } from './sprache'
import type { Datenimportstand } from './typen'

/**
 * Die Warnung im Konzernabschluss-Monitor: Datenimporte, die eine Aktualisierung brauchen
 * (5.1 Abschnitt 3.36, R880).
 *
 * **Im Wortlaut des Auftraggebers vom 2026-10-03** — mit der Anzahl und je
 * Import sein Name als Verweis. Der Verweis öffnet die Maske *Aktualisieren*
 * genau dieses Imports; CoKo selbst tut nichts.
 *
 * **Ohne Befund steht hier nichts** (R145): kein „alles aktuell".
 */
export function Aktualisierungswarnung() {
  const [betroffen, setBetroffen] = useState<Datenimportstand[]>([])

  useEffect(() => {
    let gilt = true
    // Ein Hinweis neben dem Monitor, im Hintergrund geholt (7.2 Abschnitt 30, R1007).
    imHintergrund(() => api.datenimporte())
      .then((staende) => {
        if (gilt) {
          setBetroffen(staende.filter((s) => s.aktualisierungNach))
        }
      })
      .catch(() => {
        // Ohne Liste keine Warnung — der Monitor bleibt benutzbar.
      })
    return () => {
      gilt = false
    }
  }, [])

  if (betroffen.length === 0) {
    return null
  }

  return (
    <div className="meldung aktualisierungswarnung">
      <p>
        {betroffen.length === 1
          ? t('monitor.aktualisierung.eins')
          : t('monitor.aktualisierung.mehrere', { anzahl: anzahlwort(betroffen.length) })}
      </p>
      <ul>
        {[...betroffen]
          .sort((a, b) => a.einheit.localeCompare(b.einheit) || a.periode - b.periode)
          .map((s) => (
            <li key={s.belegId}>
              <a href={aktualisierungsadresse(s.belegId)}>{belegtext(s.name)}</a>
            </li>
          ))}
      </ul>
    </div>
  )
}

/** Die Adresse, die die Maske *Aktualisieren* eines Datenimports öffnet (R156 — jeder Ort ist verlinkbar). */
export function aktualisierungsadresse(belegId: number): string {
  return `#/datenimport/lieferungen?aktualisieren=${belegId}`
}
